<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Settings | SysAdmin</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
<div class="col-lg-10">
	<h5>{{scheduler_status}}</h5>
	<div class="card card-danger card-outline">
		<div class="card-header">
  		<button @click="add" class="btn btn-danger float-right"><i class="fa fa-plus"></i> Add API</button>
  	</div>
		<div class="card-body overflow-auto">
			<datatable style="margin-top:1%;" :columns="columns">
				<tbody>
					<tr v-for="a in apis" :key="a.id">
						<td>{{a.app_name}}</td>
						<td>{{a.url}}</td>
						<td><button class="btn btn-danger" @click="edit(a)"><i class="fa fa-edit"></i> Edit</button></td>
					</tr>
				</tbody>
			</datatable>
    </div>
    <div class="card-footer">
    	<pagination :pagination="pagination"
       	@prev="getCreds(pagination.prevPageUrl)"
        @next="getCreds(pagination.nextPageUrl)"
      ></pagination>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		<button @click="addDuration" class="btn btn-danger float-right"><i class="fa fa-plus"></i> Add Timing</button>
  	</div>
		<div class="card-body overflow-auto">
			<datatable style="margin-top:1%;" :columns="dcolumns">
				<tbody>
					<tr v-for="a in timings" :key="a.id">
						<td>{{a.warranty}}</td>
						<td>{{a.first_update}}</td>
						<td>{{a.consequent_updates}}</td>
						<td>{{a.turnaround_time}}</td>
						<td><button class="btn btn-danger" @click="editTiming(a)"><i class="fa fa-edit"></i> Edit</button></td>
					</tr>
				</tbody>
			</datatable>
    </div>
    <div class="card-footer">
		</div>
	</div>
</div>
</div>



<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Payment Modes
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Mode</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in modes" :key="j.id">
								<td>{{j.mode}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.valid == 'No'" @click="changeMode(j.id, 'Yes')"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.valid == 'Yes'" @click="changeMode(j.id, 'No')"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.status ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="paymentmode" placeholder="Enter new mode">
    						<span v-if="errors.mode" :class="['badge bg-danger']">Please enter a valid mode.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addMode"><i class="fa fa-plus"></i> Add Mode</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Vendors
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Name</th>
								<th>Address</th>
								<th>GST</th>
								<th>Phone</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in vendors" :key="j.id">
								<td>{{j.name}}</td>
								<td>{{j.address}}</td>
								<td>{{j.gst}}</td>
								<td>{{j.phone}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.valid == 0" @click="changeVendor(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.valid == 1" @click="changeVendor(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.vendor ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="vendor" placeholder="Enter new vendor">
    						<span v-if="errors.vendor" :class="['badge bg-danger']">Please enter a valid vendor.</span>
    					</div>
    					<div :class="['form-group', errors.vendor_address ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="vendor_address" placeholder="Enter the vendor address">
    						<span v-if="errors.vendor_address" :class="['badge bg-danger']">Please enter a valid vendor address.</span>
    					</div>
    					<div :class="['form-group', errors.vendor_gst ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="vendor_gst" placeholder="Enter the vendor GST">
    						<span v-if="errors.vendor_gst" :class="['badge bg-danger']">Please enter a valid vendor GST.</span>
    					</div>
    					<div :class="['form-group', errors.vendor_phone ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="vendor_phone" placeholder="Enter the vendor phone">
    						<span v-if="errors.vendor_phone" :class="['badge bg-danger']">Please enter a valid vendor phone.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addVendor"><i class="fa fa-plus"></i> Add Vendor</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Service Centres
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Name</th>
								<th>Address</th>
								<th>GST</th>
								<th>Phone</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in centres" :key="j.id">
								<td>{{j.name}}</td>
								<td>{{j.address}}</td>
								<td>{{j.gst}}</td>
								<td>{{j.phone}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.valid == 0" @click="changeCentre(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.valid == 1" @click="changeCentre(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.centre ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="centre" placeholder="Enter new centre">
    						<span v-if="errors.centre" :class="['badge bg-danger']">Please enter a valid centre.</span>
    					</div>
    					<div :class="['form-group', errors.centre_address ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="centre_address" placeholder="Enter the centre address">
    						<span v-if="errors.centre_address" :class="['badge bg-danger']">Please enter a valid centre address.</span>
    					</div>
    					<div :class="['form-group', errors.centre_gst ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="centre_gst" placeholder="Enter the centre GST">
    						<span v-if="errors.centre_gst" :class="['badge bg-danger']">Please enter a valid centre GST.</span>
    					</div>
    					<div :class="['form-group', errors.centre_phone ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="centre_phone" placeholder="Enter the centre phone">
    						<span v-if="errors.centre_phone" :class="['badge bg-danger']">Please enter a valid centre phone.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addCentre"><i class="fa fa-plus"></i> Add Centre</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Taxes
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Name</th>
								<th>Tax %</th>
								<th>Description</th>
								<th>Added</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in taxes" :key="j.id">
								<td>{{j.name}}</td>
								<td>{{j.tax_perc}}</td>
								<td>{{j.description}}</td>
								<td>{{j.added}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.status == 0" @click="changeTax(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.status == 1" @click="changeTax(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.tax_name ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="tax_name" placeholder="Enter tax">
    						<span v-if="errors.tax_name" :class="['badge bg-danger']">Please enter a valid name.</span>
    					</div>
    					<div :class="['form-group', errors.tax_perc ? 'has-error' : '']">
    						<input type="number" class="form-control" v-model="tax_perc" placeholder="Enter the %" min="1">
    						<span v-if="errors.tax_perc" :class="['badge bg-danger']">Please enter a valid percentage.</span>
    					</div>
    					<div :class="['form-group', errors.tax_description ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="tax_description" placeholder="Enter the description">
    						<span v-if="errors.tax_description" :class="['badge bg-danger']">Please enter a valid description.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addTax"><i class="fa fa-plus"></i> Add Centre</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Categories
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Name</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in categories" :key="j.id">
								<td>{{j.name}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.active == 0" @click="changeCategory(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.active == 1" @click="changeCategory(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.status ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="category" placeholder="Enter new category">
    						<span v-if="errors.vendor" :class="['badge bg-danger']">Please enter a valid category.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addCategory"><i class="fa fa-plus"></i> Add Category</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Banks
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Name</th>
								<th>Code</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in banks" :key="j.id">
								<td>{{j.bank_name}}</td>
								<td>{{j.bank_code}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.status == 0" @click="changeBank(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.status == 1" @click="changeBank(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.bank_name ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="bank_name" placeholder="Enter new bank name">
    						<span v-if="errors.bank_name" :class="['badge bg-danger']">Please enter a valid bank name.</span>
    					</div>
    					<div :class="['form-group', errors.bank_code ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="bank_code" placeholder="Enter new bank code">
    						<span v-if="errors.bank_code" :class="['badge bg-danger']">Please enter a valid bank code.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addBank"><i class="fa fa-plus"></i> Add Bank</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Expense Types
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Type</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in expense_types" :key="j.id">
								<td>{{j.type}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.status == 0" @click="changeExpenseType(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.status == 1" @click="changeExpenseType(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.status ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="expense_type" placeholder="Enter new expense type">
    						<span v-if="errors.expense_type" :class="['badge bg-danger']">Please enter a valid expense type.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addExpenseType"><i class="fa fa-plus"></i> Add Type</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Income Types
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Type</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in income_types" :key="j.id">
								<td>{{j.type}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.status == 0" @click="changeIncomeType(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.status == 1" @click="changeIncomeType(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.status ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="income_type" placeholder="Enter new income type">
    						<span v-if="errors.income_type" :class="['badge bg-danger']">Please enter a valid income type.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addIncomeType"><i class="fa fa-plus"></i> Add Type</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Bill Categories
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Category</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in bill_categories" :key="j.id">
								<td>{{j.type}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.status == 0" @click="changeBillCategory(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.status == 1" @click="changeBillCategory(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.status ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="bill_category" placeholder="Enter new bill category">
    						<span v-if="errors.bill_category" :class="['badge bg-danger']">Please enter a valid category.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addBillCategory"><i class="fa fa-plus"></i> Add</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Bill Type
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Type</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in bill_types" :key="j.id">
								<td>{{j.type}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.status == 0" @click="changeBillType(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.status == 1" @click="changeBillType(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.status ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="bill_type" placeholder="Enter new bill type">
    						<span v-if="errors.bill_type" :class="['badge bg-danger']">Please enter a valid type.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addBillType"><i class="fa fa-plus"></i> Add</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Employee Performance Parameters
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Name</th>
								<th>Activity</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in epp" :key="j.id">
								<td>{{j.name}}</td>
								<td>{{j.activity}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.valid == 0" @click="changeEPP(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.valid == 1" @click="changeEPP(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.name ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="epp_name" placeholder="Enter new employee performance parameter">
    						<span v-if="errors.epp_name" :class="['badge bg-danger']">Please enter a valid parameter.</span>
    					</div>
    					<div :class="['form-group', errors.activity ? 'has-error' : '']">
    						<select v-model="epp_activity" class="form-control">
    							<option value="SALES">Sales</option>
    							<option value="SERVICE">Service</option>
    							<option value="PURCHASE">Purchase</option>
    						</select>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addEPP"><i class="fa fa-plus"></i> Add</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Turn Away Reasons
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Name</th>
								<th>Activity</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in tar" :key="j.id">
								<td>{{j.name}}</td>
								<td>{{j.activity}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.valid == 0" @click="changeTAR(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.valid == 1" @click="changeTAR(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.name ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="tar_name" placeholder="Enter new turn away reason">
    						<span v-if="errors.tar_name" :class="['badge bg-danger']">Please enter a valid reason.</span>
    					</div>
    					<div :class="['form-group', errors.activity ? 'has-error' : '']">
    						<select v-model="tar_activity" class="form-control">
    							<option value="SALES">Sales</option>
    							<option value="SERVICE">Service</option>
    							<option value="PURCHASE">Purchase</option>
    						</select>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addTAR"><i class="fa fa-plus"></i> Add</button>
    					</div>
		</div>
	</div>
</div>
</div>

<div class="col-lg-12">
<div class="col-lg-10">
	<div class="card card-danger card-outline">
		<div class="card-header">
  		Job Categories
  	</div>
		<div class="card-body overflow-auto">
				 <table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Category</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in job_categories" :key="j.id">
								<td>{{j.name}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.status == 0" @click="changeJobCategory(j.id, 1)"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.status == 1" @click="changeJobCategory(j.id, 0)"></button>
									<!--<button class="btn btn-danger fa fa-trash"></button>-->
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
    					<div :class="['form-group', errors.status ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="job_category" placeholder="Enter new job category">
    						<span v-if="errors.job_category" :class="['badge bg-danger']">Please enter a valid category.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addJobCategory"><i class="fa fa-plus"></i> Add</button>
    					</div>
		</div>
	</div>
</div>
</div>

<!-- row end -->
    </section>
<div class="modal" tabindex="-1" role="dialog" id="viewModal">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">{{heading}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">    <!-- /.content -->
							<form @submit.prevent="updateKeys">
								<div :class="['form-group', errors.app_name ? 'has-error' : '']">
									<label>App Name:</label>
									<select type="text" class="form-control" placeholder="Choose the app name" v-model="form.app_name">
										<option value="SAP-B1">SAP B1</option>
                                        <option value="SAP-S4">SAP S4</option>
										<option value="APX">APX</option>
										<option value="SuccessFactors">SuccessFactors</option>
										<option value="Dynamix">Dynamix</option>
										<option value="Tata-CloudPhone">Tata CloudPhone</option>
										<option value="Ameyo">Ameyo</option>
										<option value="Zoho-Books">Zoho Books</option>
									</select>
									<span v-if="errors.app_name" :class="['badge bg-danger']">Chooose a valid app name.</span>
								</div>
								<div :class="['form-group', errors.url ? 'has-error' : '']">
									<label>API URL:</label>
									<input type="text" class="form-control" placeholder="Enter the API URL" v-model="form.url">
									<span v-if="errors.url" :class="['badge bg-danger']">Please enter a valid URL.</span>
								</div>
								<div :class="['form-group', errors.id_name ? 'has-error' : '']">
									<label>ID Name:</label>
									<input type="text" class="form-control" placeholder="Enter the key name" v-model="form.id_name">
									<span v-if="errors.id_name" :class="['badge bg-danger']">Please enter a valid ID name.</span>
								</div>
								<div :class="['form-group', errors.id_param ? 'has-error' : '']">
									<label>ID Param:</label>
									<input type="text" class="form-control" placeholder="Enter the key value" v-model="form.id_param">
									<span v-if="errors.id_param" :class="['badge bg-danger']">Please enter a valid ID parameter.</span>
								</div>
								<div :class="['form-group', errors.key_name ? 'has-error' : '']">
									<label>Key Name:</label>
									<input type="text" class="form-control" placeholder="Enter the key name" v-model="form.key_name">
									<span v-if="errors.key_name" :class="['badge bg-danger']">Please enter a valid key name.</span>
								</div>
								<div :class="['form-group', errors.key_param ? 'has-error' : '']">
									<label>Key Param:</label>
									<input type="text" class="form-control" placeholder="Enter the key value" v-model="form.key_param">
									<span v-if="errors.key_param" :class="['badge bg-danger']">Please enter a valid key parameter.</span>
								</div>
								<div :class="['form-group', errors.key_param ? 'has-error' : '']">
									<button class="btn btn-danger" type="submit">Submit</button>
								</div>
						</form>
					</div>
					<div class="modal-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>

<div class="modal" tabindex="-1" role="dialog" id="tviewModal">
 <div class="modal-dialog" role="document">
 <div class="modal-content">
 <div class="modal-header">
        <h5 class="modal-title">{{heading}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
					<div class="modal-body">    <!-- /.content -->
							<form @submit.prevent="updateTiming">
								<div :class="['form-group', errors.warranty ? 'has-error' : '']">
									<label>Job Category:</label>
									<select class="form-control" placeholder="Enter the app name" v-model="uform.warranty">
										<option value="With Warranty">With Warranty</option>
										<option value="Without Warranty">Without Warranty</option>
										<option value="Care Pack">Care Pack</option>
										<option value="O2Protection">O2Protection</option>
										<option value="Extended Warranty">Extended Warranty</option>
										<option value="DOA">DOA</option>
										<option value="Replacement">Replacement</option>
									</select>
									<span v-if="errors.warranty" :class="['badge bg-danger']">Please choose an option.</span>
								</div>
								<div :class="['form-group', errors.first_update ? 'has-error' : '']">
									<label>First Update Time:</label>
									<input type="number" class="form-control" placeholder="Enter the duration for first update" v-model="uform.first_update" min="1">
									<span v-if="errors.first_update" :class="['badge bg-danger']">Please enter a valid number.</span>
								</div>
								<div :class="['form-group', errors.consequent_updates ? 'has-error' : '']">
									<label>Consequent Updates Time:</label>
									<input type="number" class="form-control" placeholder="Enter the duration for consequent updates" v-model="uform.consequent_updates" min="1">
									<span v-if="errors.consequent_updates" :class="['badge bg-danger']">Please enter a valid number.</span>
								</div>
								<div :class="['form-group', errors.turnaround_time ? 'has-error' : '']">
									<label>Turnaround Time:</label>
									<input type="number" class="form-control" placeholder="Enter the turnaround time" v-model="uform.turnaround_time" min="1">
									<span v-if="errors.turnaround_time" :class="['badge bg-danger']">Please enter a valid number.</span>
								</div>
								<div :class="['form-group', errors.key_param ? 'has-error' : '']">
									<button class="btn btn-danger" type="submit">Submit</button>
								</div>
						</form>
					</div>
					<div class="modal-footer">
					<button class="btn btn-secondary" data-dismiss="modal">Close</button>
				</div>
				</div>
				</div>
				</div>

<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		import Datatable from '../../datatable.vue';
    import Pagination from '../../pagination.vue';
		export default {
        mounted() {
            console.log('Component mounted.')
        },

        created(){
        	this.getParams();
        	this.getTimings();
        	this.getModes();
        	this.scheduler();
        	this.getAccessories();
        	this.getVendors();
        	this.getCentres();
        	this.getCategories();
        	this.getExpenseTypes();
        	this.getIncomeTypes();
        	this.getBillCategories();
        	this.getBillTypes();
        	this.getTaxes();
        	this.getBanks();
        	this.getEPP();
        	this.getTAR();
        	this.getJobCategories();
        },

        components: {datatable:Datatable, pagination:Pagination},

        data(){
        	let columns = [
      			{width:'25%', label:'App', name:'app_name'},
      			{width:'25%', label:'URL', name:'url'},
      			{width:'25%', label:'Edit', name:'ops'},
      		];
      		let dcolumns = [
      			{width:'20%', label:'Job Category', name:'warranty'},
      			{width:'20%', label:'First Update (In Days)', name:'first_update'},
      			{width:'20%', label:'Consequent Updates (In Days)', name:'consequent_updates'},
      			{width:'20%', label:'Turnaround Time (In Days)', name:'turnaround_time'},
      			{width:'20%', label:'Edit', name:'ops'},
      		];
        	return {
        		columns: columns,
        		dcolumns: dcolumns,
      			pagination: {
          		lastPage: '',
           		currentPage: '',
            	total: '',
            	lastPageUrl: '',
            	nextPageUrl: '',
            	prevPageUrl: '',
            	from: '',
            	to: '',
         		},
      			form: new Form({
         			id_name: '',
         			id_param: '',
         			key_name: '',
         			key_param: '',
         			app_name: '',
         			url: '',
         			id: ''
         		}),

         		uform: new Form({
         			warranty: '',
         			first_update: '',
         			consequent_updates: '',
         			turnaround_time: '',
         			id: ''
         		}),

         		apis: [],
         		errors: [],
         		heading: '',
         		timings: [],
         		modes: [],
         		paymentmode: '',
         		scheduler_status: '',
         		accessories: [],
         		accessory: '',
         		vendors: [],
         		vendor: '',
         		vendor_address: '',
         		vendor_gst: '',
         		vendor_phone: '',
         		centres: [],
         		centre: '',
         		centre_address: '',
         		centre_gst: '',
         		centre_phone: '',
         		categories: [],
         		category: '',
         		expense_types: [],
         		expense_type: '',
         		income_types: [],
         		income_type: '',
         		bill_categories: [],
         		bill_category: '',
         		bill_types: [],
         		bill_type: '',
         		taxes: [],
         		tax_name: '',
         		tax_description: '',
         		tax_perc: '',
         		bank_name: '',
         		bank_code: '',
         		banks: [],
         		epp: [],
         		epp_name: '',
         		epp_activity: '',
         		tar: [],
         		tar_name: '',
         		tar_activity: '',
         		job_categories: [],
         		job_category: ''
      		}
        },

        methods: {
        	configPagination(data){
      			this.pagination.lastPage=data.lastPage;
         		this.pagination.currentPage=data.current_page;
    	  		this.pagination.total=data.total;
        		this.pagination.lastPageUrl=data.last_page_url;
       			this.pagination.nextPageUrl=data.next_page_url;
       			this.pagination.prevPageUrl=data.prev_page_url;
     		 		this.pagination.from=data.from;
        		this.pagination.to=data.to;
    			},

        	getParams(){
        		axios.post("/api/getCreds")
        		.then(response => {
        			this.apis=response.data.data.data;
        			this.configPagination(response.data.data);
        		})
        	},

        	add(){
        		this.heading = "Add API";
        		$("#viewModal").modal("show");
        	},

        	edit(a){
        		this.heading = "Edit API";
        		this.form.fill(a);
        		$("#viewModal").modal("show");
        	},

        	updateKeys(){
        		this.form.post("/api/addKeys")
        		.then(response => {
        			if(response.data == 200){
        				toast.fire({
        					title: "Keys Updated",
        					icon: "success"
        				});
        				this.errors = [];
        				this.getParams();
        			}
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        			toast.fire({
        					title: "Failed!",
        					icon: "error"
        				});
        		})
        	},

        	addDuration(){
        		this.heading = "Add Timings";
        		this.uform.reset();
        		$("#tviewModal").modal("show");
        	},

        	editTiming(timings){
        		this.heading = "Edit Timing";
        		this.uform.fill(timings);
        		$("#tviewModal").modal("show");
        	},

        	updateTiming(){
        		this.uform.post("/api/addTimings")
        		.then(response => {
        			if(response.data == 200){
        				toast.fire({
        					title: "Timings Updated",
        					icon: "success"
        				});
        				this.errors = [];
        				this.getTimings();
        			}
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        			toast.fire({
        					title: "Failed!",
        					icon: "error"
        				});
        		})
        	},

        	getTimings(){
        		axios.post("/api/getTimings")
        		.then(response => {
        			this.timings = response.data;
        		})
        	},

        	addMode(){
        		axios.post("/api/addMode", {mode: this.paymentmode})
        		.then(response => {
        			this.getModes();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getModes(){
        		axios.post("/api/getModes")
        		.then(response => {
        			this.modes = response.data;
        		})
        	},

        	changeMode(id, status){
        		axios.post("/api/changeMode", {id: id, status: status})
        		.then(response => {
        			this.getModes();
        		})
        	},

        	scheduler(){
        		axios.post("/api/getSchedulerStatus")
        		.then(response => {
        			this.scheduler_status = response.data;
        		})
        	},

        	addAccessory(){
        		axios.post("/api/addAccessory", {accessory: this.accessory})
        		.then(response => {
        			this.getAccessories();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getAccessories(){
        		axios.post("/api/getAccessories")
        		.then(response => {
        			this.accessories = response.data;
        		})
        	},

        	changeAMode(id, status){
        		axios.post("/api/changeMode", {id: id, status: status})
        		.then(response => {
        			this.getAccessories();
        		})
        	},

        	addVendor(){
        		axios.post("/api/addVendor", {name: this.vendor, address: this.vendor_address, gst: this.vendor_gst, phone: this.vendor_phone})
        		.then(response => {
        			this.getVendors();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getVendors(){
        		axios.post("/api/getVendors")
        		.then(response => {
        			this.vendors = response.data;
        		})
        	},

        	changeVendor(id, status){
        		axios.post("/api/changeVMode", {id: id, status: status})
        		.then(response => {
        			this.getVendors();
        		})
        	},

        	addCentre(){
        		axios.post("/api/addCentre", {name: this.centre, address: this.centre_address, gst: this.centre_gst, phone: this.centre_phone})
        		.then(response => {
        			this.getCentres();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getCentres(){
        		axios.post("/api/getCentres")
        		.then(response => {
        			this.centres = response.data;
        		})
        	},

        	changeCentre(id, status){
        		axios.post("/api/changeCentreMode", {id: id, status: status})
        		.then(response => {
        			this.getCentres();
        		})
        	},

        	addCategory(){
        		axios.post("/api/addCategory", {name: this.category})
        		.then(response => {
        			this.getCategories();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getCategories(){
        		axios.post("/api/getCategories")
        		.then(response => {
        			this.categories = response.data;
        		})
        	},

        	changeCategory(id, status){
        		axios.post("/api/changeCategory", {id: id, status: status})
        		.then(response => {
        			this.getCategories();
        		})
        	},

        	addExpenseType(){
        		axios.post("/api/addExpenseType", {type: this.expense_type})
        		.then(response => {
        			this.getExpenseTypes();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getExpenseTypes(){
        		axios.post("/api/getExpenseTypes")
        		.then(response => {
        			this.expense_types = response.data;
        		})
        	},

        	changeExpenseType(id, status){
        		axios.post("/api/changeExpenseType", {id: id, status: status})
        		.then(response => {
        			this.getExpenseTypes();
        		})
        	},

        	addIncomeType(){
        		axios.post("/api/addIncomeType", {type: this.income_type})
        		.then(response => {
        			this.getIncomeTypes();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getIncomeTypes(){
        		axios.post("/api/getIncomeTypes")
        		.then(response => {
        			this.income_types = response.data;
        		})
        	},

        	changeIncomeType(id, status){
        		axios.post("/api/changeIncomeType", {id: id, status: status})
        		.then(response => {
        			this.getIncomeTypes();
        		})
        	},

        	addBillCategory(){
        		axios.post("/api/addBillCategory", {type: this.bill_category})
        		.then(response => {
        			this.getBillCategories();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getBillCategories(){
        		axios.post("/api/getBillCategories")
        		.then(response => {
        			this.bill_categories = response.data;
        		})
        	},

        	changeBillCategory(id, status){
        		axios.post("/api/changeBillCategory", {id: id, status: status})
        		.then(response => {
        			this.getBillCategories();
        		})
        	},

        	addBillType(){
        		axios.post("/api/addBillType", {type: this.bill_type})
        		.then(response => {
        			this.getBillTypes();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getBillTypes(){
        		axios.post("/api/getBillTypes")
        		.then(response => {
        			this.bill_types = response.data;
        		})
        	},

        	changeBillType(id, status){
        		axios.post("/api/changeBillType", {id: id, status: status})
        		.then(response => {
        			this.getBillTypes();
        		})
        	},

        	addTax(){
        		axios.post("/api/addTax", {name: this.tax_name, perc: this.tax_perc, description: this.tax_description})
        		.then(response => {
        			this.getTaxes();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getTaxes(){
        		axios.post("/api/getTaxes")
        		.then(response => {
        			this.taxes = response.data;
        		})
        	},

        	changeTax(id, status){
        		axios.post("/api/changeTax", {id: id, status: status})
        		.then(response => {
        			this.getTaxes();
        		})
        	},

        	addBank(){
        		axios.post("/api/addBank", {name: this.bank_name, code: this.bank_code})
        		.then(response => {
        			this.getBanks();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getBanks(){
        		axios.post("/api/getBanks")
        		.then(response => {
        			this.banks = response.data;
        		})
        	},

        	changeBank(id, status){
        		axios.post("/api/changeBank", {id: id, status: status})
        		.then(response => {
        			this.getBanks();
        		})
        	},

        	addEPP(){
        		axios.post("/api/addEPP", {name: this.epp_name, activity: this.epp_activity})
        		.then(response => {
        			this.getEPP();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getEPP(){
        		axios.post("/api/getEPP")
        		.then(response => {
        			this.epp = response.data;
        		})
        	},

        	changeEPP(id, status){
        		axios.post("/api/changeEPP", {id: id, status: status})
        		.then(response => {
        			this.getEPP();
        		})
        	},

        	addTAR(){
        		axios.post("/api/addTAR", {name: this.tar_name, activity: this.tar_activity})
        		.then(response => {
        			this.getTAR();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getTAR(){
        		axios.post("/api/getTAR")
        		.then(response => {
        			this.tar = response.data;
        		})
        	},

        	changeTAR(id, status){
        		axios.post("/api/changeTAR", {id: id, status: status})
        		.then(response => {
        			this.getTAR();
        		})
        	},

        	addJobCategory(){
        		axios.post("/api/addJobCategory", {name: this.job_category})
        		.then(response => {
        			this.getJobCategories();
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	getJobCategories(){
        		axios.post("/api/getJobCategories")
        		.then(response => {
        			this.job_categories = response.data;
        		})
        	},

        	changeJobCategory(id, status){
        		axios.post("/api/changeJobCategory", {id: id, status: status})
        		.then(response => {
        			this.getJobCategories();
        		})
        	},
        }
    }
</script>
